import React from "react";
import { useNavigate } from "react-router-dom"; // Para manejar la navegación
import Primera from "../../assets/img/service-1.jpg";
import Segunda from "../../assets/img/service-2.jpg";
import Tercera from "../../assets/img/service-3.jpg";
import Cuarta from "../../assets/img/Blanqueamiento.jpg";
import Quinta from "../../assets/img/periodoncia.jpg";
import Sexta from "../../assets/img/Ortodoncia.jpg";
import Septima from "../../assets/img/Estetica.jpg";
import Octava from "../../assets/img/Botox.jpg";
import Novena from "../../assets/img/Cirugia.jpg";
import Decima from "../../assets/img/after.jpg";

const Service = () => {
  const navigate = useNavigate(); // Hook para la navegación

  const handleWhatsApp = () => {
    window.open("https://wa.me/543815615279", "_blank");
  };

  return (
    <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
      <div className="container">
        {/* Sección con comparación antes/después */}
        <div className="row g-5 mb-5">
          <div
            className="col-lg-5 wow zoomIn"
            data-wow-delay="0.3s"
            style={{ minHeight: "400px" }}
          >
            <div className="twentytwenty-container position-relative h-100 rounded overflow-hidden">
              <img
                className="position-absolute w-100 h-100"
                src={Decima}
                alt="Antes"
                style={{ objectFit: "cover" }}
              />
              <img
                className="position-absolute w-100 h-100"
                src={Decima}
                alt="Después"
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
          <div className="col-lg-7">
            <div className="section-title mb-5">
              <h5 className="position-relative d-inline-block text-primary text-uppercase">
                Nuestro Servicio
              </h5>
              <h1 className="display-5 mb-0">
                Calidad en tratamientos y equipamiento de avanzada
              </h1>
            </div>
            {/* Primera fila de servicios */}
            <div className="row g-5">
              <div
                className="col-md-6 service-item wow zoomIn"
                data-wow-delay="0.6s"
              >
                <div className="rounded-top overflow-hidden">
                  <img className="img-fluid" src={Primera} alt="Cosmética Dental" />
                </div>
                <div className="position-relative bg-light rounded-bottom text-center p-4">
                  <h5 className="m-0">Odontología General</h5>
                </div>
              </div>
              <div
                className="col-md-6 service-item wow zoomIn"
                data-wow-delay="0.9s"
              >
                <div className="rounded-top overflow-hidden">
                  <img className="img-fluid" src={Segunda} alt="Implantes Dentales" />
                </div>
                <div className="position-relative bg-light rounded-bottom text-center p-4">
                  <h5 className="m-0">Prótesis e Implantes</h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sección de agendar turno */}
        <div className="row g-5 wow fadeInUp" data-wow-delay="0.1s">
          <div className="col-lg-5 service-item wow zoomIn" data-wow-delay="0.9s">
            <div className="position-relative bg-primary rounded h-100 d-flex flex-column align-items-center justify-content-center text-center p-4">
              <h1 className="text-white mb-3">Estamos para brindarte la mejor atención y cuidar tu sonrisa</h1>
              
              {/* Botones agregados */}
              <button
                className="btn btn-light text-primary px-8 py-3 rounded-pill mb-2"
                onClick={() => navigate("/appointment")}
              >
                Agendá tu turno
              </button>
              <button
                className="btn btn-secondary px-8 py-3 rounded-pill"
                onClick={handleWhatsApp}
              >
                Contactanos por WhatsApp
              </button>
            </div>
          </div>

          {/* Segunda fila de servicios */}
          <div className="col-lg-7">
            <div className="row g-5">
              <div className="col-md-6 service-item wow zoomIn" data-wow-delay="0.3s">
                <div className="rounded-top overflow-hidden">
                  <img className="img-fluid" src={Tercera} alt="Limpieza Dental" />
                </div>
                <div className="position-relative bg-light rounded-bottom text-center p-4">
                  <h5 className="m-0">Endodoncia</h5>
                </div>
              </div>
              <div className="col-md-6 service-item wow zoomIn" data-wow-delay="0.6s">
                <div className="rounded-top overflow-hidden">
                  <img className="img-fluid" src={Cuarta} alt="Blanqueamiento Dental" />
                </div>
                <div className="position-relative bg-light rounded-bottom text-center p-4">
                  <h5 className="m-0">Blanqueamiento Dental</h5>
                </div>
              </div>
              <div className="col-md-6 service-item wow zoomIn" data-wow-delay="0.6s">
                <div className="rounded-top overflow-hidden">
                  <img className="img-fluid" src={Quinta} alt="Periodoncia" />
                </div>
                <div className="position-relative bg-light rounded-bottom text-center p-4">
                  <h5 className="m-0">Periodoncia</h5>
                </div>
              </div>
              <div className="col-md-6 service-item wow zoomIn" data-wow-delay="0.6s">
                <div className="rounded-top overflow-hidden">
                  <img className="img-fluid" src={Sexta} alt="Ortodoncia" />
                </div>
                <div className="position-relative bg-light rounded-bottom text-center p-4">
                  <h5 className="m-0">Ortodoncia y Ortopedia</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
